<div class="tw-flex tw-justify-end tw-items-center tw-px-3 tw-pt-3 tw-pb-5">
    <button mat-icon-button (click)="onDialogClose(true)">
        <mat-icon aria-label="Close dialog">close</mat-icon>
    </button>
</div>
<div class="tw-flex tw-flex-col tw-items-center">
    <div
        class="tw-w-[49px] tw-h-[49px] tw-rounded-full tw-bg-[#4B6EEC] tw-mb-6 tw-grid tw-place-items-center"
    >
        <mat-icon aria-label="tick dialog" class="tw-scale-[1.4] tw-text-white"
            >check</mat-icon
        >
    </div>
    <div class="tw-text-2xl tw-font-semibold">{{ "PROFILE.SENT" | translate }}</div>
    <div
        class="tw-text-[#747474] tw-text-center tw-text-base tw-font-medium tw-py-7"
    >
    {{ "PROFILE.PLS_KEYIN" | translate }} <br class="md:tw-hidden" />
    </div>
    <form
        [formGroup]="varifyMobile"
        (ngSubmit)="onFormSubmit($event, varifyMobile.value)"
    >
        <div
            class="tw-grid tw-mx-[22px] tw-w-[250px] xs:tw-w-[304px] md:tw-w-[406px] tw-pb-5"
        >
            <input-general
                class="tw-block tw-w-[100%]"
                [mandatoryField]="true"
                [label]="'PROFILE.ONE_TIME' | translate"
                [placeHolder]="'PROFILE.ENTER_HERE' | translate"
                [controlName]="'otp'"
                [hideInput]="true"
               
                [errors]="getErrors('otp', 'ERROR.OTP_REQUIRED' | translate)"
                (input)="keyPressNumbers($event)"
                (paste)="pasteNumberOnly($event)"
            ></input-general>
        </div>
        <div
            class="tw-grid tw-mx-[22px] tw-w-[250px] xs:tw-w-[304px] md:tw-w-[406px] tw-pb-12"
        >
            <button
                class="tw-text-[18px] tw-leading-[20px] tw-w-full tw-text-center tw-font-[600] tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                [ngClass]="
                    disableVerifyBtn
                        ? 'tw-bg-[#E3D5C5] tw-text-white'
                        : 'tw-bg-gradient-to-r tw-from-[#FFA53C] tw-via-[#FFB74B] tw-to-[#FFB74B]'
                "
                type="submit"
                name="next"
            >
            {{ "PROFILE.VERIFY_OTP" | translate }}
            </button>
            <div>
                <div
                    class="tw-pt-6 tw-text-base tw-text-caption-gray tw-font-medium tw-text-center"
                >
                {{ "PROFILE.RESEND_COPYTEXT" | translate }}
                {{ minutes }}:{{ seconds < 10 ? "0" + seconds : seconds }} {{ "PROFILE.RESEND_SEC" | translate }}
                </div>
                <div class="tw-flex tw-justify-center">
                    <button
                        [disabled]="!resendBtn"
                        type="button"
                        class="tw-pt-3 {{
                            resendBtn ? 'tw-text-black' : 'tw-text-caption-gray'
                        }} tw-text-base tw-font-semibold tw-underline"
                        (click)="resendOtp()"
                    >
                    {{ "PROFILE.RESEND_OTP" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
